import { useLocalization } from '@fluent/react';
import { Coordinate, GeoJson, GeoJsonPoint } from '_lib/api';

export interface IvimZoneCoordinates {
  type: string;
  bbox?: number[];
  coordinates: Coordinate[];
}

interface ConnectedDenm {
  emerasId: string;
  sequenceNumber: string;
}

export interface IvimText {
  language: string;
  value: string;
}

export interface IvimMetaData {
  connectedDenms?: ConnectedDenm[];
  freeText: IvimText[];
  extraText: IvimText[];
  rsus?: string[];
  datexii?: {
    description: string;
  };
}

export interface Ivim {
  id: string;
  sequenceNumber: number;
  iviType: number;
  serviceCategoryCode: string;
  serviceSubCategoryCode: string;
  pictogramNature: number;
  pictogramSerialNumber: number;
  language: string;
  text: string[];
  countryCode: string;
  providerIdentifier: string;
  direction: number;
  broadcastingFrequency: number;
  detZoneCoordinates: IvimZoneCoordinates;
  relZoneCoordinates: IvimZoneCoordinates;
  referencePoint: GeoJsonPoint;
  roadSegmentId: string;
  starts: string;
  ends: string;
  expiresAt: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  disabled: boolean;
  metadata: IvimMetaData;
  source: string;
}

export enum IvimStatusFilter {
  IN_PROGRESS = 'in_progress',
  CLOSED = 'closed',
  DISABLED = 'disabled',
  SCHEDULED = 'scheduled',
}

export enum IvimSourceFilter {
  EMERAS = 'emeras',
  DATEXII = 'datexii',
  DENM = 'denm',
  TMS_UPER = 'tms-uper',
}

export enum IvimDateFilterType {
  RELATIVE = 'relative',
  ABSOLUTE = 'absolute',
}

export interface IvimReducerState {
  subscriptionId?: string;
  loading: boolean;
  loadingCSV: boolean;
  statusFilter: IvimStatusFilter | '';
  sourceFilter: IvimSourceFilter[];
  dateFilter: string;
  updatedFromFilter: Date;
  updatedToFilter: Date;
  dateFilterType: IvimDateFilterType;
  roadSegmentId: string;
  total: number;
  paginationCurrentPage?: number;
  paginationItemsPerPage?: number;
  serviceCategoryCodeFilter?: string;
  serviceSubCategoryCodeFilter?: string;
  allData: Ivim[];
}

export const ivimType = () => {
  const { l10n } = useLocalization();
  return [
    { value: 0, label: l10n.getString('forms-ivim-type-danger') },
    { value: 1, label: l10n.getString('forms-ivim-type-regulatory') },
    { value: 2, label: l10n.getString('forms-ivim-type-traffic') },
    { value: 3, label: l10n.getString('forms-ivim-type-pollution') },
    { value: 4, label: l10n.getString('forms-ivim-type-not-traffic') },
  ];
};

export const mapIvimType = (type: number, l10n: any) => {
  switch (type) {
    case 0:
      return l10n.getString('forms-ivim-type-danger');
    case 1:
      return l10n.getString('forms-ivim-type-regulatory');
    case 2:
      return l10n.getString('forms-ivim-type-traffic');
    case 3:
      return l10n.getString('forms-ivim-type-pollution');
    case 4:
      return l10n.getString('forms-ivim-type-not-traffic');
    default:
      return l10n.getString('forms-ivim-type-danger');
  }
};
